import { EmployeesTeamHeadcount } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ExportRow, GenerateExport } from './export'

export default class HeadcountByTeam implements GenerateExport {
  private headcountByTeam: EmployeesTeamHeadcount[]

  constructor(headcountByTeam: EmployeesTeamHeadcount[]) {
    this.headcountByTeam = headcountByTeam
  }

  isEmpty() {
    return !this.headcountByTeam.length
  }

  export() {
    const data: ExportRow[][] = [
      [
        i18n.t('insights.widgets.headcount_by_team.team_header'),
        i18n.t('insights.widgets.shared.headcount'),
      ],
    ]

    this.generate().forEach(({ label, value }) => {
      data.push([label, value])
    })

    return {
      title: i18n.t('insights.widgets.headcount_by_team.title'),
      data,
    }
  }

  generate() {
    return this.headcountByTeam.map((entry) => ({ label: entry.teamName, value: entry.headcount }))
  }
}
